<script>
import HasForm from '@/components/forms/has-form';

export default {
  name: 'popups.distribution-group.update-users',

  mixins: [HasForm],

  components: {
    ElForm: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElForm'),
  },

  props: {
    group: {
      required: true,
    },
  },

  data: () => ({
    toRemoveDistributionGroupUsers: [],
    newDistributionGroupUsers: [],
  }),

  methods: {
    MoveRight(userId) {
      this.newDistributionGroupUsers.push(userId);
    },

    MoveLeft(userId) {
      this.newDistributionGroupUsers = this.newDistributionGroupUsers.filter(id => id !== userId);
      this.toRemoveDistributionGroupUsers.push(userId);
    },

    async submit() {
      this.loading = true;
      console.log(this.newDistributionGroupUsers);
      let promisesLink = this.newDistributionGroupUsers.map(async user_id => {
        await this.$store.dispatch('distributionGroup/link', {
          user_id,
          workspace_id: this.workspace.id,
          group_id: this.group.id,
        });
      });

      let promisesUnlink = this.group.users
        .filter(u => this.toRemoveDistributionGroupUsers.includes(u.id))
        .map(async user => {
          await this.$store.dispatch('distributionGroup/unlink', {
            user_id: user.id,
            workspace_id: this.workspace.id,
            group_id: this.group.id,
          });
        });

      await Promise.all([...promisesLink, ...promisesUnlink]);

      this.handleSuccess();

      this.$emit('close');

      this.loading = false;
    },
  },

  computed: {
    workspace() {
      return this.$store.getters['workspace/current'];
    },

    availableUsers() {
      let idLeftMap = new Set([...this.toRemoveDistributionGroupUsers]);
      let idRightMap = new Set([...this.group.users.map(dg => dg.id), ...this.newDistributionGroupUsers]);

      return this.workspace.users.filter(dg => idLeftMap.has(dg.id) || !idRightMap.has(dg.id));
    },

    distributionGroupUsers() {
      let idLeftMap = new Set([...this.group.users.map(dg => dg.id), ...this.newDistributionGroupUsers]);
      let idRightMap = new Set([...this.toRemoveDistributionGroupUsers]);

      return this.workspace.users.filter(dg => idLeftMap.has(dg.id) && !idRightMap.has(dg.id));
    },
  },
};
</script>

<template>
  <div class="popup">
    <div class="popup-header">
      <p class="mb-0 fs-17 fw-b">
        <i class="fal fa-folder-plus mr-8"></i>
        {{ $t(`${$options.name}.title`) }}
      </p>
      <div class="close" @click="$emit('close')"></div>
    </div>
    <div class="popup-content pt-0">
      <div class="add-panel">
        <div class="left">
          <div class="title">Gebruikers</div>
          <div class="panel">
            <div class="user-card" v-for="user in availableUsers" :key="user.id" @click="MoveRight(user.id)">
              <span>{{ user.first_name }} {{ user.last_name }}</span>
              <i class="fa fa-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title">Toegevoegd</div>
          <div class="panel">
            <div class="user-card" v-for="user in distributionGroupUsers" :key="user.id" @click="MoveLeft(user.id)">
              <i class="fa fa-arrow-left"></i>
              <span>{{ user.first_name }} {{ user.last_name }}</span>
            </div>
          </div>
        </div>
      </div>
      <el-form class="w-100" @submit="submit()" :error="server_error" :loading="loading" :success="success" button-text="buttons.adjust"> </el-form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.add-panel {
  display: flex;
  flex-flow: row nowrap;
  gap: 16px;
  min-height: 200px;
  .left,
  .right {
    width: 50%;
    height: 100%;
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    .panel {
      padding: 15px;
      background: whitesmoke;
      border-radius: 4px;
      width: 100%;
      display: flex;
      flex-flow: column;
      gap: 14px;
      height: 300px;
      overflow: auto;
    }

    .user-card {
      transition: all 0.3s;
      cursor: pointer;
      border: 1px solid #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:hover {
        border-color: var(--primary);
        i {
          opacity: 1;
        }
      }
      i {
        opacity: 0;
        transition: all 0.3s;
      }
    }
  }

  .user-card {
    background: #fff;
    padding: 4px 8px;
    border-radius: 4px;
  }

  .left {
  }
  .right {
  }
}
</style>
